import { createElement } from 'react';
import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { FluxoPage } from '@/features/workflow/FluxoPage';
import { FluxosPage } from '@/features/workflow/FluxosPage';
import { CAMINHO_FLUXO, CAMINHO_FLUXOS } from '@/features/workflow/navegacao';

/**
 * Rotas das telas de fluxo.
 *
 * Exportadas como **fábrica**, pelo mesmo motivo das outras features:
 * `createRoute` exige a rota pai, e o pai (`appRoute`, com a casca e a guarda
 * de sessão) mora em `app/router.tsx`. Receber o pai por parâmetro deixa a
 * integração ser uma linha lá, sem que esta feature importe de dentro de
 * `app/` — o que fecharia um ciclo entre o roteador e a tela que ele monta.
 *
 * Duas rotas irmãs, e não uma raiz com filhas: a lista e a definição não
 * compartilham casca. A definição é uma tela inteira, com cabeçalho próprio e
 * caminho de volta — a mesma decisão de `features/clientes/routes.ts`.
 */
export function criarRotasDeFluxos<TRotaPai extends AnyRoute>(rotaPai: TRotaPai) {
  const lista = createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_FLUXOS,
    component: FluxosPage,
  });

  const detalhe = createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_FLUXO,
    // `createElement` em vez de JSX para este arquivo continuar sendo `.ts`, e
    // a conversão do parâmetro porque o roteador só consegue inferir
    // `{ definicaoId }` depois que a árvore estiver registrada.
    component: () => {
      const { definicaoId } = detalhe.useParams() as { definicaoId: string };
      return createElement(FluxoPage, { definicaoId });
    },
  });

  return { lista, detalhe };
}

export { CAMINHO_FLUXO, CAMINHO_FLUXOS };
